<script>
  import Modal from '@/components/Modal';
  import FormInput from '@/components/Form/Input';

  export default {
    components: {
      Modal,
      FormInput,
    },

    data: () => ({
      form: {
        name: '',
        agency: '',
        account: '',
      },
    }),

    created () {
      const item = this.$store.state.bank.list.find(({ id }) => id == this.$route.params.bank_id);

      if (item) {
        return this.form = {
          ...item
        };
      }

      if (this.$route.params.bank_id) {
        this.close();
      }
    },

    methods: {
      close () {
        this.$router.push('/conta/contas-bancarias');
      },

      save () {
        this.close();

        this.$store.commit('bank/SAVE', this.form);
      },
    },
  };
</script>

<template>
  <Modal
    @close="close"
    class="account-add"
    title="Lucas Leandro"
    subtitle="151.648.979-94"
    >
    <form
      @submit.prevent="save"
      class="account-add__form"
      >
      <FormInput
        required
        type="text"
        floating
        v-model="form.name"
        label="Nome do banco"
        />

      <div class="account-add__row">
        <FormInput
          required
          type="text"
          floating
          label="Agência"
          v-model="form.agency"
          class="account-add__small"
          />

        <FormInput
          required
          type="text"
          floating
          label="Conta"
          v-model="form.account"
          />
      </div>

      <button class="modal__action modal__action--full" type="submit">
        {{ form.id ? 'Atualizar conta' : 'Adicionar conta' }}
      </button>
    </form>
  </Modal>
</template>

<style lang="scss">
  .account-add {
    .form-input {
      flex: 3;
      width: 100%;
    }

    &__row {
      display: flex;
      margin-bottom: 8px;
    }

    &__small {
      flex: 2 !important;
      margin-right: 24px;
    }

    .form-input--focus .form-input__label--floating {
      background-color: #26273f;
    }
  }
</style>
